import { useEffect } from "react";
import { Link } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";

// Catch-all for unknown URLs. A static host can't send a real 404 for SPA routes,
// so this page tells crawlers not to index it (avoids soft-404 duplicates).
export default function NotFound() {
  usePageMeta("Page Not Found | American Farmstand", "This page doesn't exist on American Farmstand.", null);
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    if (!el) { el = document.createElement("meta"); el.name = "robots"; document.head.appendChild(el); }
    el.content = "noindex, follow";
    return () => el.remove();
  }, []);
  return (
    <div className="min-h-[70vh] bg-white pt-36 pb-24 px-6 text-center" data-not-found="true" data-testid="not-found-page">
      <p className="text-xs tracking-widest uppercase" style={{ color: '#8f7d45' }}>404</p>
      <h1 className="mt-3 text-3xl" style={{ color: '#0f1d2f', fontFamily: "'GFS Didot', 'Didot', Georgia, serif" }}>Page not found</h1>
      <p className="mt-3 text-sm" style={{ color: '#0f1d2f', opacity: 0.65 }}>The page you&rsquo;re looking for has moved or never existed.</p>
      <Link to="/" className="inline-block mt-8 px-6 py-3 text-xs tracking-widest uppercase" style={{ backgroundColor: '#0f1d2f', color: '#fff' }} data-testid="not-found-home">Back to the farmstand</Link>
    </div>
  );
}
